import { gql } from "@apollo/client";
import { Account, accountFragment, Wallet, walletFragment } from "common/graphql/fragments";

export const CREATE_WALLET = gql`
  mutation CreateWallet(
    $payeeAccountId: uuid!
    $paymentPreference: String!
    $desiredBalance: numeric!
    $minimumBalance: numeric!
    $isFreeTrial: Boolean = false
  ) {
    createWallet: create_wallet(
      payee_account_id: $payeeAccountId
      payment_preference: $paymentPreference
      desired_balance: $desiredBalance
      minimum_balance: $minimumBalance
      is_free_trial: $isFreeTrial
    ) {
      wallet {
        ...walletFragment
      }
      account {
        ...accountFragment
      }
    }
  }
  ${walletFragment}
  ${accountFragment}
`;

export interface CreateWalletData {
  createWallet: {
    wallet: Wallet;
    account: Account;
  };
}

export interface CreateWalletVars {
  paymentPreference: "wallet_balance" | "session";
  payeeAccountId: string;
  desiredBalance: number;
  minimumBalance: number;
  isFreeTrial?: boolean;
}
